import { useState, useEffect, FC, ReactNode } from 'react';
import ReactDOM from 'react-dom';

type TPortal = {
  /** Что добавляем в портал */
  children: ReactNode;
  /** Кастомный класс */
  className?: string;
  /** Если не хотим обертку */
  inBody?: boolean;
};

const Portal: FC<TPortal> = ({ children, className, inBody }) => {
  const [container] = useState(() => document.createElement('div'));

  useEffect(() => {
    if (container && className && !container.classList.contains(className)) {
      container.classList.add(className);
    }
  }, [className, container]);

  useEffect(() => {
    const parent = document.body;
    parent.appendChild(container);
    return () => {
      if (parent && container && parent.contains(container)) {
        try {
          parent.removeChild(container);
        } catch (err) {
          console.log('Ошибка при удалении портала:', err);
        }
      }
    };
  }, [container]);

  return ReactDOM.createPortal(children, inBody ? document.body : container);
};

export default Portal;
